import * as React from "react";
import { BackendTypesEnum } from "../../../api-client";
import { Badge } from "../../../components/ui/badge";

type CloudBackendChipProps = {
  hosted: boolean;
  backend: BackendTypesEnum;
};
export const CloudBackendChip = ({
  hosted,
  backend,
}: CloudBackendChipProps): React.ReactElement => {
  if (hosted) {
    return <Badge variant="outline">Hosted</Badge>;
  }
  switch (backend) {
    case BackendTypesEnum.VmAws:
      return (
        <Badge
          style={{
            color: "white",
            backgroundColor: "#FF9900",
          }}
        >
          AWS
        </Badge>
      );
    case BackendTypesEnum.VmGcp:
      return (
        <Badge
          style={{
            color: "white",
            backgroundColor: "#179C52",
          }}
        >
          GCP
        </Badge>
      );
    case BackendTypesEnum.VmAzure:
      return (
        <Badge
          style={{
            color: "white",
            backgroundColor: "#007FFF",
          }}
        >
          Azure
        </Badge>
      );
    default:
      return <Badge>{backend}</Badge>;
  }
};
